import React from 'react';
import { ExternalReference } from 'graphql-query-contracts';
import { useTranslation } from 'react-i18next';
import { Flex } from 'components';
import { SourceTypeLabel } from '../../type-maps/source-type-label.map';

type Props = {
  reference: ExternalReference;
};

export const ViewExternalReference = ({ reference }: Props) => {
  const { t } = useTranslation();
  const { sourceEntityId, sourceType } = reference.source;

  const sourceTypeValue = SourceTypeLabel[sourceType];
  const sourceEntityIdValue = sourceEntityId || '-';

  return (
    <Flex direction="row" gap={2}>
      <Flex direction="column">
        <b>{sourceEntityIdValue}</b>
        <Flex direction="row" gap={2}>
          <span>
            {t('web.components.viewExternalReference.sourceType.label')}
          </span>
          <span>{sourceTypeValue}</span>
        </Flex>
      </Flex>
    </Flex>
  );
};
